import { render } from "./SectionEvents.vue?vue&type=template&id=7847c73c"
import script from "./SectionEvents.vue?vue&type=script&lang=js"
export * from "./SectionEvents.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__